// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__ll3xz","main":"SecOne_main__AKyGh","gif":"SecOne_gif__ZtpZ5"};